<header>{{ headlining() }}</header>
<section #section>
	<ng-content select="[content]"></ng-content>
</section>
<footer>
	<ng-content select="[extra-action]"></ng-content>
	<button actioner color="basic" mat-dialog-close [disabled]="exitButton$ | async">Exit</button>
	<ng-content select="[action]"></ng-content>
</footer>
